/**
 * 発注 積替運搬サマリー
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/requests/pickups`

const order_request_pickup = {
  namespaced: true,
  actions: {
    /**
     *
     * @return {Promise<unknown>}
     */
     show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
         let content = data.content
         resolve(content)
        })
      })
    },
  },
  mutations: {},
}

export default order_request_pickup
